import dayjs from "dayjs";

/**
 * Turns the API's sync state into the one sentence the panel shows.
 *
 * Split out of the screen because it is the only part of this page with a
 * decision in it, and a decision is worth testing without a DOM. Same
 * arrangement as `SiteUpdates/rebuildState`.
 *
 * The distinction that matters is **stale versus not synced**. Both look like
 * "the glossary is not doing what this list says", but one is a DeepL failure
 * that will keep failing until someone looks, and the other is the ordinary
 * state of an empty list. Collapsing them would hide the first behind the
 * second.
 */

/** Clock time in the reader's own timezone. Null when there is nothing to show. */
export const formatMoment = (value) => (value ? dayjs(value).format("DD MMM YYYY, HH:mm") : null);

export const describeSync = (sync, termCount = 0) => {
  const state = sync ?? {};

  // A recorded error means the stored glossary no longer matches this list:
  // DeepL is still being handed the last one that built.
  if (state.lastError) {
    return {
      state: "stale",
      tone: "warning",
      message: state.glossaryId
        ? "DeepL все още използва предишния речник — най-новите промени още не са приложени."
        : "Речникът не можа да бъде изпратен на DeepL, затова нито един от тези термини не се прилага.",
      detail: state.lastError,
      at: formatMoment(state.lastErrorAt),
    };
  }

  if (!state.glossaryId) {
    // Not an error: an empty list has nothing to upload, and DeepL rejects an
    // empty glossary. Saying "failed" here would send someone hunting.
    return {
      state: termCount > 0 ? "pending" : "empty",
      tone: "info",
      message:
        termCount > 0
          ? "Тези термини все още не са стигнали до DeepL. Използвай „Синхронизирай с DeepL“."
          : "Все още няма термини. Преводите вървят без речник, докато не добавиш такъв.",
      detail: null,
      at: null,
    };
  }

  return {
    state: "synced",
    tone: "success",
    message: `DeepL използва тези ${state.termCount ?? 0} ${
      state.termCount === 1 ? "термин" : "термина"
    } при превод от български на английски.`,
    detail: null,
    at: formatMoment(state.lastSyncedAt),
  };
};
